import { Injectable } from "@angular/core";
import { Http } from "@angular/http";

// import { Observable } from 'rxjs/Observable';
// import { CookieService } from 'angular2-cookie/core';
import { CookieService } from "ngx-cookie";
import { Storage } from "../storage/storage";

import { Observable, Observer, Subject } from "rxjs";

@Injectable()
export class AuthService {
  hook_url: any;

  constructor(
    private http: Http,
    private _cookieService: CookieService,
    private storage: Storage
  ) { }

  getLogin(username, password, hook_url) {
    var subject = new Subject<boolean>();

    if (this.storage.hook_url === undefined) {
      this.storage.hook_url = hook_url;
    }

    this.http
      .post("http://api.microstore.nendi.fr/microstore/login", {
        username,
        password,
        hook_url,
      })
      .map((res) => {
        return res.json();
      })
      .subscribe((res) => {
        if (res.login) {
          this._cookieService.put("NendiToken", res.token);
          subject.next(true);
        } else {
          subject.next(false);
        }
      });
    return subject.asObservable().first();
  }

  isJwtValid(token, hook_url) {
    if (this.storage.hook_url === undefined) {
      this.storage.hook_url = hook_url;
    }
    return this.http
      .post("http://api.microstore.nendi.fr/microstore/isJwtValid", { token })
      .map((res) => {
        return res.json().logged;
      });
  }

  isOracleJwtValid(token, hook_url) {
    if (this.storage.hook_url === undefined) {
      this.storage.hook_url = hook_url;
    }
    return this.http
      .post(
        "https://api.microstore-oracle.nendi.fr/microstore/isOracleJwtValid",
        {
          token,
        }
      )
      .map((res) => res.json().logged);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts